import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/meadow-bg.webp'
import modalBg from '../../img/meadow-modal-bg-1.svg'
import contentImg1 from '../../img/meadow-img1.webp'
import {Preloader, SpriteSvg} from '../../components'

import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import bgImg2 from "../../img/meadow-imgBg-2.webp";
import bgImg3 from "../../img/meadow-imgBg-3.webp";
import bgImg4 from "../../img/meadow-imgBg-4.webp";
import {useMousePosition} from "../../utils";


const MeadowPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	meadowPage,
	afterMeadowGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState(false)

	useEffect(()=> {
		window.TN_BACKPACK.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	const position = useMousePosition()



	const handleMeadowGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_BACKPACK.showStartMessage()
		window.TN_BACKPACK.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, meadowPage])
			setIsVisibleGame(false)
			handleNextPage(afterMeadowGamePage)
		}
	}

	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
				<div id='area' className={cn(
					'game-wrap',
					isVisibleGame && 'active'
				)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'meadow-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg right-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={sun6} alt=""/>
				<img className='meadow-bgImg2' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={bgImg2} alt=""/>
				<img className='meadow-bgImg3' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={bgImg3} alt=""/>
				<img className='meadow-bgImg4' style={{transform: `translate(${position.x / 350}px, ${position.y / 350}px)`}} src={bgImg4} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
							 'modal',
					modalContentChange &&
					'disabled'
						 )}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Ну что, начнём? А что это у тебя на плече? Нет, {name}, так не пойдёт. Для восхождения тебе потребуется настоящий рюкзак со снаряжением, а не эта новомодная сумка!</p>
								<p className='mg-b-24'>Обменяй её на походный рюкзак. Местные девушки тебе в этом помогут. Они всегда рады помочь дерзкому путнику.</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange(true)} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Обменять сумку</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'modal',
					!modalContentChange &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-4'>Отлично, рюкзак уже у тебя. Осталось наполнить его только самым необходимым для подъёма.</p>

								<p className='mg-b-4'>Помимо снаряжения, чтобы покорить гору, тебе нужно обладать определёнными качествами: <b>Знанием, Мастерством, Опытом, Ловкостью и Силой</b>. На пути будет множество испытаний. Проходя их, ты будешь прокачивать эти качества.</p>
									<p className='mg-b-4'>Начнём!</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleMeadowGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Собрать рюкзак</p>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default MeadowPage